import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';

import { ResultListModel } from '../../providers/result/result';
import { TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from '../../providers/config/config';
import { SettingsProvider } from '../../providers/settings/settings';

@Component({
  selector: 'trophy',
  templateUrl: 'trophy.html',
  styleUrls:['./trophy.scss']
})
export class TrophyComponent {
  @Input('result')
  result: ResultListModel;


  @Input('offset')
  offset: string;

  @ViewChild('container')
  container: ElementRef;

  trophy: Trophy;

  active: Trophy3DModel = null;
  pipeDateFormat = "dd.MM.yyyy";

  constructor(
      public datePipe: DatePipe,
      private settingsService: SettingsProvider,
      private translate: TranslateService,
      private config: ConfigProvider) {
    // @ts-ignore
    this.trophy = STROPHY;
    this.settingsService.getActiveDateFormat().then(date => {
      this.pipeDateFormat = date.pipeFormat;
    });
    console.log('constructor ');
  }

  ngAfterViewInit() {
    this.parseModel(this.result).then(m => {
      console.log('m: ', m);
      this.checkEqueals(m).then(hasCahnged => {
        console.log('hasCahnged: ', hasCahnged);
        console.log('this.container.nativeElement: ', this.container.nativeElement);

        if (hasCahnged) {
          this.active = m;
          this.trophy.start(m, this.container.nativeElement);
        }
      });
    });
  }

  ionViewWillLeave() {
    this.trophy.stop();
    this.active = null;
  }

  switch(model: ResultListModel) {
    this.parseModel(model).then(m => {
      this.checkEqueals(m).then(hasCahnged => {
        if (hasCahnged) {
          this.result = model;
          this.active = m;
          this.trophy.swap(m);
        }
      });
    });
  }

  async checkEqueals(model: Trophy3DModel): Promise<boolean> {
    let r = this.active;
    let l = r !== null;
    if (l) {
      let or: boolean = false;
      Object.keys(r).forEach(key => {
        or = or || r[key] !== model[key];
      });
      l = l && or;
    } else {
      l = true;
    }
    return l;
  }

  async parseModel(model: ResultListModel): Promise<Trophy3DModel> {
    console.log('parseModel');
    console.log('model', model)
    let off = parseInt(this.offset);
    let headers = document.querySelectorAll('ion-navbar');
    console.log('headers: ', headers);
    let headerOff;
    if (headers.length > 0) {
      //@ts-ignore
      headerOff = parseInt(headers[headers.length - 1].offsetHeight);
    } else {
      headerOff = 0;
    }
    let NOff: number = 3;

    if (!isNaN(off)) {
      //@ts-ignore
      NOff += off + headerOff;
    } else {
      NOff += headerOff;
    }
    let conf = await this.config.config;
    if (conf.platform.browser || !conf.ads || conf.ads.type !== 'google') {
      NOff += 50;
    }

    return !model
      ? {
        offset: NOff + '',
        athleteName: this.translate.instant('TROPHY_YOU_HAVE_NO_RESULTS'),
        eventName: ''
      }
      : {
        athleteName: model.athleteName,
        eventName: model.eventName,
        distance: model.streckeconv,
        time: this.timeFormat(model.gtime),
        formatedDate: this.datePipe.transform(model.eventDate, this.pipeDateFormat),
        platz: model.gplatz,
        hasStrecke: model.hasStrecke,
        hasZeit: model.hasZeit,
        hasDatum: model.hasDatum,
        hasPlatz: model.hasPlatz,
        trophyColor: model.trophyColor,
        trophyMaterial: model.trophyMaterial,
        trophyType: model.trophyType,
        offset: NOff + ''
      };
  }

  timeFormat(time: number): string {
    let hour = Math.floor(time / 3600);
    time -= hour * 3600;
    let min = Math.floor(time / 60);
    time -= min * 60;

    return this.zeroHelp(hour) + ':' + this.zeroHelp(min) + ':' + this.zeroHelp(time);
  }

  zeroHelp(number): string {
    return number < 10 ? '0' + number : number;
  }
}

interface Trophy3DModel {
  athleteName?: string;
  eventName?: string;
  distance?: string;
  time?: string;
  formatedDate?: string;
  platz?: number;
  hasStrecke?: boolean;
  hasZeit?: boolean;
  hasDatum?: boolean;
  hasPlatz?: boolean;
  trophyColor?: string;
  trophyMaterial?: string;
  trophyType?: string;
  offset?: string;
}

interface Trophy {
  start(model: Trophy3DModel, element: HTMLElement);
  stop();
  swap(model: Trophy3DModel);
}
